import React from "react";
import Button from "../ui/button";

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  rowsPerPage,
  totalItems = 0,
}) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center mt-6 mb-4">
      <div className="flex items-center gap-2">
        {/* Prev Button */}
        <Button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-full sm:w-auto"
          bgColor="bg-colorButton"
          textColor="text-white"
        >
          Prev
        </Button>

        {/* Page Numbers with Ellipsis */}
        {(() => {
          const pages = [];
          let startPage, endPage;

          if (totalPages <= 4) {
            startPage = 1;
            endPage = totalPages;
          } else if (currentPage === 1) {
            startPage = 1;
            endPage = 2;
          } else if (currentPage === 2) {
            startPage = 1;
            endPage = 3;
          } else if (currentPage >= totalPages - 1) {
            startPage = totalPages - 2;
            endPage = totalPages;
          } else {
            startPage = currentPage - 1;
            endPage = currentPage + 1;
          }

          // Beginning ellipsis
          if (startPage > 1) {
            pages.push(
              <button
                key={1}
                onClick={() => onPageChange(1)}
                className={`w-6 h-6 rounded-full flex items-center justify-center border text-sm font-medium transition-all ${
                  currentPage === 1
                    ? "bg-primary text-white border-primary"
                    : "text-gray-700 border-gray-400 hover:bg-gray-100"
                }`}
              >
                1
              </button>
            );
            if (startPage > 2) {
              pages.push(
                <span key="start-ellipsis" className="text-gray-500 px-2">
                  ...
                </span>
              );
            }
          }

          // Visible pages
          for (let i = startPage; i <= endPage; i++) {
            pages.push(
              <button
                key={i}
                onClick={() => onPageChange(i)}
                className={`w-6 h-6 rounded-full flex items-center justify-center border text-sm font-medium transition-all ${
                  currentPage === i
                    ? "bg-primary text-white border-primary"
                    : "text-gray-700 border-gray-400 hover:bg-gray-100"
                }`}
              >
                {i}
              </button>
            );
          }

          // Ending ellipsis
          if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
              pages.push(
                <span key="end-ellipsis" className="text-gray-500 px-2">
                  ...
                </span>
              );
            }
            pages.push(
              <button
                key={totalPages}
                onClick={() => onPageChange(totalPages)}
                className={`w-6 h-6 rounded-full flex items-center justify-center border text-sm font-medium transition-all ${
                  currentPage === totalPages
                    ? "bg-primary text-white border-primary"
                    : "text-gray-700 border-gray-400 hover:bg-gray-100"
                }`}
              >
                {totalPages}
              </button>
            );
          }

          return pages;
        })()}

        {/* Next Button */}
        <Button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-full sm:w-auto"
          bgColor="bg-colorButton"
          textColor="text-white"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
